import { ThunkType } from "../../../../core/store/reducers";
import deleteStockFeeApi from "../api/deleteStockFee";
import { setFetchState } from "../stockFeesDataReducer";

export const deleteStockFee = (sfId: number): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteStockFeeApi(userId, sfId));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
};
